import { useMemo, useEffect } from 'react';
import { eventBus } from '@atc/cai-event-bus';
import { UDS_GET_INCENTIVES_REQUEST, debugWallet, UDS_GET_INCENTIVES_COMPLETED } from 'wallet-manager';
import { getIncentives } from 'reaxl-wallet';

/**
 * Hook that handles external incentives requests via event bus. Fetches incentives data when
 * `UDS_GET_INCENTIVES_REQUEST` is received, then emits `UDS_GET_INCENTIVES_COMPLETED` with the results.
 *
 * @param {string} activeTab - Current active deal type
 * @param {string} dealerId - Dealer ID
 * @param {string} partnerId - Partner ID ('MMD', etc.)
 * @param {string} listingType - Type of listing ('new', 'used')
 * @param {string} vin - Vehicle identification number
 * @param {string} zip - ZIP code
 * @param paymentIncentivesFetcher
 * @returns {void}
 */
const useExternalIncentivesRequest = _ref => {
  let {
    activeTab,
    dealerId,
    partnerId,
    listingType,
    vin,
    zip,
    paymentIncentivesFetcher
  } = _ref;
  const incentivesParams = useMemo(() => ({
    dealerId,
    dealType: activeTab,
    listingType: listingType && listingType[0].toUpperCase() + listingType.slice(1),
    partnerId,
    vin,
    zip
  }), [activeTab, dealerId, listingType, partnerId, vin, zip]);
  useEffect(() => {
    const handleIncentivesRequest = async () => {
      const incentivesUrl = new URLSearchParams(incentivesParams).toString();
      try {
        const incentivesData = await getIncentives({
          incentivesFetcher: paymentIncentivesFetcher,
          incentivesUrl
        });
        debugWallet('UDS', 'getIncentives:completed', incentivesData);
        eventBus.emit(UDS_GET_INCENTIVES_COMPLETED, incentivesData);
      } catch (error) {
        debugWallet('UDS', 'getIncentives:error', error);
        eventBus.emit(UDS_GET_INCENTIVES_COMPLETED, {
          incentives: []
        });
      }
    };
    eventBus.on(UDS_GET_INCENTIVES_REQUEST, handleIncentivesRequest);
    return () => eventBus.off(UDS_GET_INCENTIVES_REQUEST, handleIncentivesRequest);
  }, [incentivesParams, paymentIncentivesFetcher]);
};
export { useExternalIncentivesRequest as default };
